<template>
    <div class="footer-box">
        <div class="row" style="display: flex;width: 1200px;margin: 20px auto;justify-content: space-between;">
			<div >
				<div class="col-title">
					<span>咨询电话/地址</span>
				</div>
				<div style="display: flex;">
					<div class="col-md-6 school-info">
						<span class="school-name">长梅总部</span>
						<div class="col-tel iphone">
							<img src="../assets/images/tel-icon.png" class="col-tel__icon"/>
							<span>8545-6811</span>
						</div>
						<div class="col-addr">
							<img src="../assets/images/addr-icon.png" class="col-tel__icon"/>
							<span>岳麓区旭辉御府A栋三楼整层</span>
						</div>
					</div>
					<div class="col-md-6 school-info">
						<span class="school-name">立信旗舰校区</span>
						<div class="col-tel iphone">
							<img src="../assets/images/tel-icon.png" class="col-tel__icon"/>
							<span>8397-7129</span>
						</div>
						<div class="col-addr">
							<img src="../assets/images/addr-icon.png" class="col-tel__icon"/>
							<span>立信学校右侧观山悦大厦六楼</span>
						</div>
					</div>
				
					<div class="col-md-6 school-info">
						<span class="school-name">青竹湖校区</span>
						<div class="col-tel iphone">
							<img src="../assets/images/tel-icon.png" class="col-tel__icon"/>
							<span>188-7466-0102</span>
						</div>
						<div class="col-addr">
							<img src="../assets/images/addr-icon.png" class="col-tel__icon"/>
							<span>开福区太阳山社区A14栋1楼</span>
						</div>
					</div>
					<div class="col-md-6 school-info">
						<span class="school-name">一中校区</span>
						<div class="col-tel iphone">
							<img src="../assets/images/tel-icon.png" class="col-tel__icon"/>
							<span>8545-7985</span>
						</div>
						<div class="col-addr">
							<img src="../assets/images/addr-icon.png" class="col-tel__icon"/>
							<span>营盘中路13号（一中斜对面）</span>
						</div>
					</div>
				</div>
			</div>
			<div style="padding-left: 0 !important;">
				<div class="col-title">
					<span>关注我们</span>
				</div>
				<!-- <div class="row" style="margin: 10px 0 0 0;"> -->
					<div class="col-md-5 official-account">
						<img src="../assets/images/wechat-qr.jpg" class="qr-pic"/>
						<span>微信公众号</span>
					</div>
					<!-- <div class="col-md-5 official-account">
						<img src="../assets/images/video-qr.jpg" class="qr-pic"/>
						<span>微信视频号</span>
					</div> -->
				<!-- </div> -->
			</div>
		</div>
        <div style="color: #999;width: 70%;margin: auto;text-align: center;border-top: 1px solid #424242;padding: 20px;font-size: 14px;">
            
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #999;">备案号：湘ICP备19003129号-1</a>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'footerh',
    props: {
      msg: String
    }
  }
  </script>
  
  
  <style scoped>
      .row {
          display: flex;
          width: 100%;
      }
      .col-md-6 {
          /* width: 50%; */
		  width: 220px;
		  margin-right: 30px;
      }
      .col-md-5 {
          width: 42%;
      }
      .footer-box {
        background-color: #333;
        padding: 50px 0 0;
      }
  .col-title{
	font-size: 22px;
	font-weight: 500;
	color: #969696;
	margin-bottom: 20px;
}
.school-info .school-name{
	display: block;
	font-size: 18px;
	font-weight: 500;
	color: #969696;
	position: relative;
	margin-top: 12px;
	padding-left: 8px;
}
.school-info .school-name:after{
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	width: 3px;
	height: 100%;
	background: #969696;
}
.school-info .col-tel,
.school-info .col-addr{
	display: flex;
	align-items: center;
	/* margin-top: 4px; */
}
.school-info .col-tel .col-tel__icon{
	width: 18px;
	height: 18px;
	margin-left: -2px;
}
.school-info .col-addr .col-tel__icon{
	width: 18px;
	height: 22px;
	margin-left: -2px;
}
.school-info .col-tel span,
.school-info .col-addr span{
	font-size: 14px;
	font-weight: 500;
	color: #999;
	display: block;
	margin-left: 8px;
}
 .official-account{
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-left: 0 !important;
	position: relative;
}
.official-account .qr-pic{
	width: 100px;
	height: 100px;
}
.official-account span{
	display: flex;
	width: 100px;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
	color: #969696;
}
.iphone {
	margin: 10px 0;
}

  </style>